/* socks-bundle-new + socks-new: wrap the express buy button and the add-to-cart row
   in one container. Below the fold it is ordinary content; as soon as its
   bottom edge reaches the bottom of the viewport it is fixed there (mobile
   only, via CSS) and stays pinned while the original spot is above the
   viewport. The switch happens exactly where the element already is, so
   nothing slides in. Scrolling back up, it rejoins the flow the moment the
   original spot returns and grows back to full width in place.
   Loaded from layout/theme.liquid behind a template.suffix guard. The s1-pdp
   section replaces itself on fit switches, so we re-run on DOM changes. */
(() => {
  const SCRIPT = document.currentScript;
  const MOBILE = window.matchMedia('(max-width: 767px)');

  function setup(root) {
    if (root.querySelector('.sb-float')) return;
    const buy = root.querySelector('[data-s1-buy-button]');
    const atc = root.querySelector('[data-s1-atc]');
    const first = buy || atc;
    if (!first || !first.parentNode) return;

    const wrap = document.createElement('div');
    wrap.className = 'sb-float';
    const ph = document.createElement('div');
    ph.className = 'sb-float__ph';
    first.parentNode.insertBefore(ph, first);
    first.parentNode.insertBefore(wrap, first);
    if (buy) wrap.appendChild(buy);
    if (atc) wrap.appendChild(atc);

    /* pinned width as a share of the in-flow width; set in the theme editor
       (Socks bundle page config → Pinned width) via data-sb-shrink */
    const SHRINK = (parseInt(SCRIPT?.dataset.sbShrink, 10) || 70) / 100;

    let fixed = false;
    let fullWidth = 0;
    let clearTimer = 0;

    /* ---- spacer (16/09/2026) ----
       The spacer only has to hold the block's height for the frame the bar
       detaches. At that moment the spot sits under the fixed bar and
       everything below it is off-screen, so the spacer collapses to 0 right
       there: the only content that moves is content nobody can see (the bar's
       white fade masks the slivers around the buttons). It stays collapsed
       until the bar rejoins the flow, so the buttons never leave a hole
       behind. No height animation, no per-frame layout. If a flick pinned the
       bar late (spot already well above the bar), the collapse waits until
       the spot is clear of the viewport and corrects the scroll position by
       the measured shift so nothing visible moves. */
    const BUFFER = 80;
    let collapsed = false;
    let spacerHeight = 0;
    const anchorEl = () => {
      let el = ph.nextElementSibling;
      while (el && (el === wrap || !el.offsetParent)) el = el.nextElementSibling;
      return el || ph.parentNode;
    };
    const collapse = (compensate) => {
      if (collapsed) return;
      collapsed = true;
      if (!compensate) { ph.style.height = '0px'; return; }
      const anchor = anchorEl();
      const before = anchor.getBoundingClientRect().top;
      ph.style.height = '0px';
      const shift = anchor.getBoundingClientRect().top - before;
      if (shift) window.scrollBy(0, shift);
    };

    const fix = () => {
      if (fixed) return;
      fixed = true;
      clearTimeout(clearTimer);
      fullWidth = wrap.offsetWidth;
      spacerHeight = wrap.offsetHeight;
      collapsed = false;
      ph.style.height = spacerHeight + 'px';
      ph.classList.add('is-active');
      /* start at exactly the in-flow size, then ease to the target */
      wrap.style.width = fullWidth + 'px';
      wrap.classList.add('is-pinned');
      void wrap.offsetWidth;
      /* Collapse now unless the pin fired very late. Scroll events arrive
         once per frame, so a flick can carry the spot 50-100px past the bar
         before we hear about it; within PIN_TOLERANCE the only content that
         shifts is a thin strip at the bottom edge of a fast-moving page (the
         bar's white fade covers the first 28px of it), which is far less
         visible than leaving the hole for the whole pass. Beyond that the
         off-screen, scroll-compensated path in check() takes over. */
      const PIN_TOLERANCE = 160;
      const spot = ph.getBoundingClientRect();
      if (spot.top >= window.innerHeight - wrap.offsetHeight - PIN_TOLERANCE) collapse(false);
      requestAnimationFrame(() => {
        if (fixed) wrap.style.width = Math.round(fullWidth * SHRINK) + 'px';
      });
    };
    const unfix = () => {
      if (!fixed) return;
      fixed = false;
      collapsed = false;
      /* rejoin the flow right away at the original position; the width
         eases back to full size in place (the wrapper is centred), then the
         inline width is dropped so the buttons follow the column again */
      wrap.classList.remove('is-pinned');
      ph.classList.remove('is-active');
      ph.style.height = '';
      void wrap.offsetWidth;
      wrap.style.width = fullWidth + 'px';
      clearTimer = setTimeout(() => { if (!fixed) wrap.style.width = ''; }, 400);
    };

    const check = () => {
      if (!MOBILE.matches) { unfix(); return; }
      const vh = window.innerHeight;
      if (!fixed) {
        /* in flow: fix the moment the bottom edge meets the viewport bottom */
        if (wrap.getBoundingClientRect().bottom <= vh) fix();
        return;
      }
      /* the spot as if it still had its full height */
      const spot = ph.getBoundingClientRect();
      const spotBottom = spot.top + (collapsed ? spacerHeight : spot.height);
      /* the original spot is back at the bottom edge: rejoin the flow there,
         so the buttons are never above their original position */
      if (spotBottom > vh) { unfix(); return; }
      /* late pin: collapse once the spot is clear above the viewport */
      if (!collapsed && spotBottom < -BUFFER) collapse(true);
    };

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('scrollend', check, { passive: true });
    window.addEventListener('resize', check);
    MOBILE.addEventListener('change', check);
    check();
  }

  const init = () => document.querySelectorAll('s1-pdp').forEach(setup);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();
